<template>
  <a-tabs v-model:activeKey="tabkey" @change="getData">
    <a-tab-pane key="1" tab="管理账号"></a-tab-pane>
    <a-tab-pane key="2" tab="商户账号"></a-tab-pane>
  </a-tabs>
  <a-space>
    <a-button v-if="tabkey === '1'" type="danger" @click="addAccount">
      <template #icon>
        <PlusOutlined />
      </template>
      新增账号
    </a-button>
    <a-button type="link" @click="getData">刷新数据</a-button>
  </a-space>
  <a-table :columns="columns" bordered :data-source="data" :loading="dataLoading" :scroll="{ x: width, y: 600 }"
    :pagination="{
      current: page,
      pageSize: limit,
      total: count,
      showQuickJumper: true,
      showSizeChanger: true,
    }" @change="(pagination) => {
      page = pagination.current;
      limit = pagination.pageSize;
    }">
    <template #bodyCell="{ record, column }">
      <template v-if="column.dataIndex === 'role'">
        {{ getrolename(record.role) }}
      </template>
      <template v-if="column.dataIndex === 'operation'">
        <a-space>
          <a v-if="tabkey === '1'" href="javascript:;" @click="editAccount(record)">编辑</a>
        </a-space>
      </template>
    </template>
  </a-table>
  <a-modal v-model:visible="accountModal" title="新增账号" @ok="saveAccount" @cancel="cancelSave" ok-text="确认"
    cancel-text="取消" :confirm-loading="saving" :cancel-button-props="{ disabled: saving }" :maskClosable="false"
    :closable="!saving">
    <a-form ref="accountFormRef" name="accountForm" :model="accountForm" :label-col="{ span: 6 }"
      :wrapper-col="{ span: 18 }" autocomplete="off">
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-item label="账号" name="username" :rules="[{ required: true, message: '请输入账号' }]">
            <a-input v-model:value="accountForm.username" placeholder="账号" :disabled="accountForm._id !== '' || saving">
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="密码" name="password">
            <a-input v-model:value="accountForm.password"
              :placeholder="accountForm._id === '' ? '密码，留空则系统自动生成' : '密码，留空则不修改'" :disabled="saving">
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="姓名" name="name">
            <a-input v-model:value="accountForm.name" placeholder="姓名" :disabled="saving">
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="角色" name="role" :rules="[{ required: true, message: '请选择角色' }]">
            <a-select v-model:value="accountForm.role" :options="roles" placeholder="请选择" :disabled="saving" />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="状态" name="enabled">
            <a-checkbox v-model:checked="accountForm.enabled">
              <span class="text-success" v-if="accountForm.enabled">启用</span>
              <span class="text-error" v-else>停用</span>
            </a-checkbox>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>
<script setup>
import { PlusOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import { ref, watch, computed, onMounted, getCurrentInstance, } from "vue";
import _ from "underscore";

const { proxy } = getCurrentInstance();
const accountFormRef = ref();

const tabkey = ref("1");
const dataLoading = ref(false);
const page = ref(1);
const limit = ref(20);
const length = ref(0);
const count = ref(0);
const data = ref([]);
const roles = ref([]);
const accountForm = ref({});
const accountModal = ref(false);
const saving = ref(false);

const columns = computed(() => {
  if (tabkey.value === '1') {
    return [
      { title: '账号', dataIndex: 'username', width: 100 },
      { title: '初始密码', dataIndex: 'initpwd', width: 120 },
      { title: '姓名', dataIndex: 'name', width: 150 },
      { title: '角色', dataIndex: 'role', width: 120, },
      { title: '登录时间', dataIndex: 'last_login_time', width: 150, },
      { title: '活跃时间', dataIndex: 'last_active_time', width: 150, },
      { title: '创建时间', dataIndex: 'create_time', width: 150, },
      { title: '操作', dataIndex: 'operation', width: 100, fixed: 'right' }
    ];
  }
  if (tabkey.value === '2') {
    return [
      { title: '商户名称', dataIndex: 'name', width: 120 },
      { title: '主账号', dataIndex: 'username', width: 100 },
      { title: '登录时间', dataIndex: 'last_login_time', width: 150, },
      { title: '活跃时间', dataIndex: 'last_active_time', width: 150, },
      { title: '创建时间', dataIndex: 'create_time', width: 150, },
      { title: '操作', dataIndex: 'operation', width: 100, fixed: 'right' }
    ];
  }
});
const width = computed(() => proxy.$utils.twidth(columns.value));

watch(() => page.value, () => {
  getData();
});
watch(() => limit.value, () => {
  if (page.value !== 1) page.value = 1;
  else getData();
});

onMounted(() => {
  getData();
});

const getData = () => {
  dataLoading.value = true;
  proxy.$api.doAPI("/account/list", { page: page.value, limit: limit.value, tabkey: tabkey.value }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      data.value = _.map(res.data.list, n => {
        return {
          ...n,
          create_time: proxy.$dateFormat(n.create_time, 'YYYY-MM-DD HH:mm'),
          last_login_time: n.last_login_time ? proxy.$dateFormat(n.last_login_time, 'YYYY-MM-DD HH:mm') : '-',
          last_active_time: n.last_active_time ? proxy.$dateFormat(n.last_active_time, 'YYYY-MM-DD HH:mm') : '-',
        }
      });
      length.value = res.data.length;
      count.value = res.data.count;
      if (length.value > 0 && page.value > length.value) page.value = 1;
      roles.value = res.data.roles;
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
};
const initForm = () => {
  return {
    _id: "", username: "", password: "", name: "", role: undefined, enabled: true,
  };
};
const addAccount = () => {
  accountForm.value = initForm();
  accountModal.value = true;
};
const editAccount = (item) => {
  accountForm.value = _.extend(initForm(), _.pick(item, _.keys(initForm())));
  accountModal.value = true;
}
const saveAccount = async () => {
  try {
    await accountFormRef.value.validateFields();
    saving.value = true;
    proxy.$api.doAPI("/account/save", { dataForm: accountForm.value }).then((res) => {
      saving.value = false;
      if (res.code === 0) {
        accountModal.value = false;
        message.success("保存成功");
        getData();
      } else {
        message.error(res.msg);
      }
    }).catch((err) => {
      saving.value = false;
      console.error(err);
    });
  } catch (errorInfo) {
    console.log("Failed:", errorInfo);
  }
};
const cancelSave = () => {
  accountFormRef.value.clearValidate();
  accountModal.value = false;
};
const getrolename = (role) => {
  return _.findWhere(roles.value, { value: role })?.label;
}
</script>
<style lang="less" scoped>
:deep(.ant-layout-header) {
  display: flex;
  padding: 0 20px;
}

:deep(.ant-table-thead > tr > th) {
  padding: 8px 8px !important;
}

p {
  margin: 0;
  padding: 0;
}
</style>